import React, { Component } from "react";
import { Modal, Form, Card, Row, Col } from "react-bootstrap";

class ConvoMediaFiles extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: window.matchMedia("(max-width:600px)").matches,
            uploading: false,
        };
    }

    componentDidMount() {
        this.mediaQuery = window.matchMedia("(max-width:600px)");
        this.handleMQ = (e) => this.setState({ isMobile: e.matches });
        this.mediaQuery.addEventListener("change", this.handleMQ);
    }

    componentWillUnmount() {
        if (this.mediaQuery) this.mediaQuery.removeEventListener("change", this.handleMQ);
    }

    async handleSubmit(e) {
        e.preventDefault();
        const { selectedFiles = [], handleClose, handleMessageSubmit, onUploadFile } = this.props;

        if (!selectedFiles?.length) {
            console.error("Please select a file");
            return;
        }

        const firstFile = selectedFiles[0].file || selectedFiles[0];

        let messageType = "";
        if (firstFile.type.startsWith("image/")) messageType = "image";
        else if (firstFile.type.startsWith("video/")) messageType = "video";
        else if (firstFile.type === "application/pdf") messageType = "document";
        else {
            console.error("Unsupported file type");
            return;
        }

        const filesPayload = selectedFiles.map((item) => {
            const file = item.file || item;
            const previewUrl = item.base64Data || URL.createObjectURL(file);
            return { filename: file.name, img: previewUrl };
        });

        this.setState({ uploading: true });
        try {
            if (onUploadFile) {
                const uploadedPath = await onUploadFile(filesPayload);
                if (uploadedPath) {
                    console.log("File uploaded successfully");
                    await handleMessageSubmit(e, uploadedPath);
                } else {
                    console.error("File upload failed");
                }
            } else {
                console.error("Upload handler not configured");
            }
        } catch {
            console.error("Something went wrong");
        } finally {
            this.setState({ uploading: false });
        }
    }

    render() {
        const { open, handleClose, selectedFiles = [], removeFile, typeMessage, onMessageChange } = this.props;
        const { uploading } = this.state;

        return (
            <Modal show={open} onHide={handleClose} size="md">
                <Modal.Header>
                    <Modal.Title>Uploaded Files</Modal.Title>
                    <button type="button" className="close" onClick={handleClose}>
                        <span>&times;</span>
                    </button>
                </Modal.Header>

                <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
                    {uploading ? (
                        <div className="d-flex justify-content-center align-items-center py-4">
                            <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Uploading...</span>
                            </div>
                        </div>
                    ) : (
                        <Row>
                            {selectedFiles.map((item, index) => {
                                const file = item.file || item;
                                const previewUrl = item.base64Data || URL.createObjectURL(file);
                                const isImage = file.type.startsWith("image/");
                                const isVideo = file.type.startsWith("video/");
                                const isPDF = file.type === "application/pdf";

                                return (
                                    <Col xs={12} key={index} className="mb-2">
                                        <Card style={{ width: 150, position: "relative", border: "1px solid #ddd" }}>
                                            <button
                                                className="btn btn-sm p-0"
                                                onClick={() => removeFile(index)}
                                                style={{
                                                    position: "absolute", top: 4, right: 4,
                                                    backgroundColor: "var(--btn-1)",
                                                    borderRadius: 4, zIndex: 1,
                                                    width: 22, height: 22,
                                                    display: "flex", alignItems: "center", justifyContent: "center",
                                                }}
                                            >
                                                <i className="fas fa-times" style={{ fontSize: 11 }} />
                                            </button>

                                            {isImage ? (
                                                <Card.Img
                                                    variant="top"
                                                    src={previewUrl}
                                                    alt={file.name}
                                                    style={{ height: 120, objectFit: "cover" }}
                                                />
                                            ) : isVideo ? (
                                                <video
                                                    src={previewUrl}
                                                    controls
                                                    style={{ height: 120, objectFit: "cover", width: "100%" }}
                                                />
                                            ) : isPDF ? (
                                                <div style={{ height: 120, display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#f5f5f5" }}>
                                                    <iframe src={previewUrl} width="100%" height="100%" title={file.name} />
                                                </div>
                                            ) : (
                                                <div style={{
                                                    height: 120, display: "flex", justifyContent: "center",
                                                    alignItems: "center", backgroundColor: "#f5f5f5",
                                                    fontSize: 14, textAlign: "center", padding: 8,
                                                }}>
                                                    {file.name.split(".").pop().toUpperCase()}
                                                </div>
                                            )}

                                            <Card.Body className="p-1 text-center">
                                                <small style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "block" }} title={file.name}>
                                                    {file.name}
                                                </small>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                );
                            })}
                        </Row>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <div className="d-flex w-100" style={{ gap: 8 }}>
                        <Form.Control
                            as="textarea"
                            rows={1}
                            value={typeMessage || ""}
                            onChange={onMessageChange}
                            placeholder="Type a message"
                            style={{ borderRadius: 10, resize: "none" }}
                        />
                        <button
                            className="btn"
                            onClick={(e) => this.handleSubmit(e)}
                            style={{ color: "var(--primary)", border: "2px solid var(--primary)", borderRadius: 8, padding: "0 12px" }}
                        >
                            <i className="fas fa-paper-plane" />
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ConvoMediaFiles;
